import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './LegalConsentModal.css';

interface LegalConsentModalProps {
    isOpen: boolean;
    onAccept: () => void;
    imageUrl?: string;
}

const LegalConsentModal: React.FC<LegalConsentModalProps> = ({ isOpen, onAccept, imageUrl }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setVisible(true);
            // Lock body scroll
            document.body.style.overflow = 'hidden';
        } else {
            setTimeout(() => setVisible(false), 300); // Wait for animation
            document.body.style.overflow = 'unset';
            document.body.style.overflowX = 'hidden';
        }

        return () => {
            document.body.style.overflow = 'unset';
            document.body.style.overflowX = 'hidden';
        };
    }, [isOpen]);

    if (!visible && !isOpen) return null;

    return (
        <div className={`legal-consent-backdrop ${isOpen ? 'open' : ''}`}>
            <div className={`legal-consent-modal ${isOpen ? 'open' : ''}`}>
                <div className="legal-consent-image-container">
                    <img
                        src={imageUrl || "https://res.cloudinary.com/dr4l6amyu/image/upload/v1703606990/legal_consent_polaroid.png"}
                        alt="Style Preview"
                        className="legal-consent-polaroid"
                    />
                </div>

                <h2 className="legal-consent-title">BİRKAÇ İZNİN GEREKİYOR</h2>

                <div className="legal-consent-content">
                    <p>
                        Uygulamayı kullanırken verilerinizin işlenmesi hakkında bilgilendirme:
                    </p>
                    <p>
                        <Link to="/kullanim-kosullari" target="_blank" rel="noopener noreferrer">Kullanım Koşulları</Link>,{' '}
                        <Link to="/acik-riza-metni" target="_blank" rel="noopener noreferrer">Açık Rıza Metni</Link> ve{' '}
                        <Link to="/kvkk-aydinlatma-metni" target="_blank" rel="noopener noreferrer">KVKK Aydınlatma Metni</Link>'ni
                        kabul etmiş sayılırsınız. Lütfen inceleyiniz.
                    </p>
                    <p className="legal-consent-disclaimer">
                        Sistem hatalar yapabilir, lütfen sonuçları kontrol edin.
                    </p>
                </div>

                <button className="legal-consent-button" onClick={onAccept}>
                    Tamamdır, hadi başlayalım
                </button>
            </div>
        </div>
    );
};

export default LegalConsentModal;
